export default "__VITE_ASSET__DqFeW3PL__"